import request from '@/utils/request'

// 用户管理：分页查询
export function userPage(data) {
    return request({
      url: '/authority/user/page',
      method: 'post',
      data
    }).then((res) => {
      return Promise.resolve(res);
    });
}

// 用户管理：详情查询
export function userDetail(id) {
    return request({
        url: '/authority/user/Detail/'+id,
        method: 'get',
    }).then((res) => {
        return Promise.resolve(res.data);
    });
}

// 用户管理：禁用按钮
export function upUserStatus(data) {
    return request({
        url: '/authority/user/upUserStatus/',
        method: 'put',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 用户管理：新增
export function addUser(data) {
    return request({
        url: '/authority/user/addUser',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 用户管理：修改
export function editUser(data) {
    return request({
        url: '/authority/user/editUser',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 站点：查询所有店铺信息
export function queryShopAll() {
    return request({
        url: '/base/market/listActive',
        method: 'get',
    }).then((res) => {
        return Promise.resolve(res);
    });
}


// 用户管理：部门结构树
export function orgTree() {
    return request({
        url: '/authority/org/tree',
        method: 'get',
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 编辑节点树
export function getEditTree(id) {
    return request.get(`/authority/org/superior?id=${id}`)
      .then((res) => {
          return Promise.resolve(res);
      })
}

// 用户管理：新增部门
export function addOrg(data) {
    return request({
        url: '/authority/org',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 用户管理：修改部门
export function updaOrg(data) {
    return request({
        url: '/authority/org',
        method: 'put',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 用户管理：删除部门
export function delOrg(ids) {
    return request({
        url: '/authority/org?ids[]='+ids,
        method: 'delete',
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 角色：查询所有角色
export function queryRoleAll() {
    return request({
        url: '/authority/role/queryAll',
        method: 'get',
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 角色：新增角色
export function addRole(data) {
    return request({
        url: '/authority/role',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}


// 角色：修改角色
export function updateRole(data) {
    return request({
        url: '/authority/role',
        method: 'put',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 角色：删除角色
export function delRole(ids) {
    return request({
        url: '/authority/role?ids[]='+ids,
        method: 'delete',
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 角色：查询角色的用户
export function queryRoleUser(id) {
    return request({
        url: '/authority/role/user/'+id,
        method: 'get',
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 用户：查询出所有用户
export function findAll() {
    return request({
        url: '/authority/user/findAll',
        method: 'get',
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 用户：用户下拉框（所有用户）
export function userCombobox() {
    return request({
        url: '/authority/user/userCombobox',
        method: 'get',
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 角色：删除用户角色关联关系
export function delUserRole(data) {
    return request({
        url: '/authority/role/delUser',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 角色配置用户
export function configUserRole(data) {
    return request({
        url: '/authority/role/user',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 角色：功能权限查询
export function allAuthTree(id) {
    return request({
        url: '/authority/menu/allAuthTree?roleId='+id,
        method: 'get',
    }).then((res) => {
        return Promise.resolve(res);
    });
}


// 角色：功能权限保存
export function upAuthority(data) {
    return request({
        url: '/authority/role/upAuthority',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 字段权限-查询
export function queryRoleFields(data) {
    return request({
        url: '/authority/role/queryFields',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 字段权限-修改
export function saveRoleFields(data) {
    return request({
        url: '/authority/role/saveFields',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 套餐管理：产品套餐查询
export function queryProPackageData() {
    return request({
        url: '/defaults/productPackage/new/queryData',
        method: 'get'
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// export function queryProPackageData() {
//     return request({
//         url: '/defaults/productPackage/queryData',
//         method: 'get'
//     }).then((res) => {
//         return Promise.resolve(res);
//     });
// }

// 套餐管理：查询对公账户信息
export function queryCorporate() {
    return request({
        url: '/defaults/productPackage/queryCorporate',
        method: 'get'
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 套餐管理：对公转账信息录入
export function saveCorporate(data) {
    return request({
        url: '/defaults/productPackage/saveCorporate',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 套餐管理：生成支付宝充值记录 及 支付二维码
export function alipayRecharge(data) {
    return request({
        url: '/defaults/productPackage/alipayRecharge',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 套餐管理：生成中行充值记录 及 支付二维码
export function bocRecharge(data) {
    return request({
        url: '/defaults/productPackage/bocRecharge',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

//支付操作：取消 或 确认
export function alterPayStatus(data) {
    return request({
        url: '/defaults/productPackage/alterPayStatus',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

//支付操作：刷新支付二维码
export function refreshQRCode(outTradeNo) {
    return request({
        url: '/defaults/productPackage/refreshQRCode/'+outTradeNo,
        method: 'get',
    }).then((res) => {
        return Promise.resolve(res);
    });
}

//支付操作：刷新支付二维码 中行
export function refreshQRCodeBOC(outTradeNo) {
    return request({
        url: `/defaults/productPackage/refreshQRCodeByBoc/${outTradeNo}`,
        method: 'get',
    }).then((res) => {
        return Promise.resolve(res);
    });
}

//充值记录：分页查询
export function payRecordPage(data) {
    return request({
        url: '/base/payRecord/page',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}


export function getStorageArgs(data) {
    return request({
        url: '/supply/inventoryIndex/query',
        method: 'get',
        data
    }).then((res) => {
        return Promise.resolve(res.data);
    });
}

export function updateStorageArgs(params) {
    return request.put('/supply/inventoryIndex', params)
      .then((res) => {
          return Promise.resolve(res);
      });
}

export function getStatisticsArgs(params) {
    return request.get('/operation/globalParameter/query', {params})
      .then((res) => {
          return Promise.resolve(res.data);
      });
}

export function updateStatisticsArgs(params) {
    return request.put('/operation/globalParameter', params)
      .then((res) => {
          return Promise.resolve(res);
      });
}

// 财务与成本配置查询
export function apiSupplyFinanceAndCostQuery(params) {
    return request.get('/supply/financeAndCost/query', params)
      .then((res) => {
          return Promise.resolve(res);
      });
}

// 财务与成本配置更
export function apiSupplyFinanceAndCost(params) {
    return request.put('/supply/financeAndCost', params)
      .then((res) => {
          return Promise.resolve(res);
      });
}

export function feeShareWayList() {
    return request.post('/finance/feeShareWay/list')
      .then((res) => {
          return Promise.resolve(res);
      });
}

export function feeShareWay(params) {
    return request.put('/finance/feeShareWay', params)
      .then((res) => {
          return Promise.resolve(res);
      });
}


// 售后任务（NRNF系统设置）

// 售后任务（NRNF系统设置修改）
export function updateReviewConfig() {
    return request.post('/reviewConfig/updateReviewConfig')
        .then((res) => {
            return Promise.resolve(res);
        });
}


// 售后任务配置查询
export function reviewConfigGet() {
    return request.get('/crm/reviewConfig')
        .then((res) => {
            return Promise.resolve(res);
        });
}
// 售后任务配置修改
export function reviewConfigPut(params) {
    return request.put('/crm/reviewConfig', params)
        .then((res) => {
            return Promise.resolve(res);
        });
}

//充值记录套餐剩余量
export function getPayRecordQuantity() {
    return request.get('/base/payRecord/quantity')
    .then((res) => {
        return Promise.resolve(res.data);
    });
}